import React from 'react';
import { JobPostingDetailsForm } from '.';
import { NumberField } from './NumberField';
import { SimpleSelectField } from './SimpleSelectField';
import { RadioPill } from '../../../../components/RadioPill';
import { FormGroup } from './FormGroup';
import { Label } from 'reactstrap';

interface PropTypes {
  form: JobPostingDetailsForm;
  errors: Record<string, string>;
  onInputChange: (name: string, value: unknown) => void;
}

export function JobRequirementsFields(props: PropTypes) {
  return (
    <FormGroup>
      <h4>Job Requirements</h4>
      <NumberField
        label='Years of Experience'
        value={props.form.yearsOfExperience}
        name='yearsOfExperience'
        onInputChange={props.onInputChange}
        mandatory={true}
        error={props.errors['yearsOfExperience']}
      />
      <SimpleSelectField
        label='Salary period'
        options={[
          { label: 'Yearly', value: 'yearly' },
          { label: 'Monthly', value: 'monthly' },
        ]}
        value={props.form.salaryPeriod}
        name='salaryPeriod'
        onInputChange={props.onInputChange}
        mandatory={true}
      />
      <div>
        <Label>
          Salary Currency <span className='ps-1 text-danger'>*</span>
        </Label>
        <div className='d-flex fs-5'>
          <RadioPill
            name='salaryCurrency'
            id='salaryCurrency-EUR'
            label={'EUR'}
            value={'EUR'}
            selectedValue={props.form.salaryCurrency}
            onChange={() => props.onInputChange('salaryCurrency', 'EUR')}
          />
          <RadioPill
            name='salaryCurrency'
            id='salaryCurrency-USD'
            label={'USD'}
            value={'USD'}
            selectedValue={props.form.salaryCurrency}
            onChange={() => props.onInputChange('salaryCurrency', 'USD')}
          />
          <RadioPill
            name='salaryCurrency'
            id='salaryCurrency-GBP'
            label={'GBP'}
            value={'GBP'}
            selectedValue={props.form.salaryCurrency}
            onChange={() => props.onInputChange('salaryCurrency', 'GBP')}
          />
        </div>
      </div>
      <div className='d-flex gap-2'>
        <NumberField
          className='w-50'
          label='Salary Range'
          value={props.form.salaryRangeFrom}
          name='salaryRangeFrom'
          onInputChange={props.onInputChange}
          placeholder='From'
          error={props.errors['salaryIndication']?.['range']?.['from']}
        />
        <NumberField
          className='w-50'
          label='To'
          value={props.form.salaryRangeTo}
          name='salaryRangeTo'
          onInputChange={props.onInputChange}
          mandatory={true}
          placeholder='To'
          error={props.errors['salaryIndication']?.['range']?.['to']}
        />
      </div>
      <div className='d-flex gap-2'>
        <NumberField
          className='w-50'
          label='Weekly Hours Range'
          value={props.form.weeklyHoursFrom}
          name='weeklyHoursFrom'
          onInputChange={props.onInputChange}
          placeholder='From'
          error={props.errors['weeklyWorkingHours']?.['from']}
        />
        <NumberField
          className='w-50'
          label='To'
          value={props.form.weeklyHoursTo}
          name='weeklyHoursTo'
          onInputChange={props.onInputChange}
          mandatory={true}
          placeholder='To'
          error={props.errors['weeklyWorkingHours']?.['to']}
        />
      </div>
    </FormGroup>
  );
}
